import React, { MouseEvent } from 'react'

import { A } from '@driftt/tide-core'

import ActivityIcon from 'components/ActivityIcon'
import { ActivityForContact } from 'modules/accountActivity/domain'
import { timeSinceUpdated } from 'utils/timeStamp'

import FormattedActivity from '../FormattedActivity'

import styles from './styles.module.css'

interface ActivityListProps {
  activityList: ActivityForContact[]
  maxActivitiesToShow: number
  onClickShowMoreActivities: () => void
}

const ActivityList: React.FC<ActivityListProps> = ({
  activityList,
  maxActivitiesToShow,
  onClickShowMoreActivities
}) => {
  return (
    <>
      {activityList.slice(0, maxActivitiesToShow).map((activity: ActivityForContact, i: number) => (
        <div key={i} className={styles.activityInfo}>
          <div className={styles.iconAndTime}>
            <ActivityIcon className={styles.icon} activityType={activity.activityType} />
            <div className={styles.activityTime}>{`${timeSinceUpdated(
              activity.createdAt
            )} ago`}</div>
          </div>
          <FormattedActivity activity={activity} />
        </div>
      ))}
      {activityList.length > maxActivitiesToShow && (
        <A
          className={styles.loadMore}
          onClick={(e: MouseEvent<HTMLButtonElement>) => {
            e.stopPropagation()
            onClickShowMoreActivities()
          }}>
          Load more activities
        </A>
      )}
    </>
  )
}

export default ActivityList
